<template>
    <div>
        <b-card>
            <validation-observer ref="salaryValidation">
                <div class="form">
                    <validation-provider #default="{ errors }" name="grade" rules="required">
                        <GradeComp :validation="validations" :value="formData.grade" :errors="errors" @values="formData.grade = $event" />
                    </validation-provider>
                    <validation-provider #default="{ errors }" name="position" rules="required">
                      <PositionComp :validation="validations" :value="formData.position" :errors="errors" @values="formData.position = $event" />
                    </validation-provider>
                    <validation-provider #default="{ errors }" name="parent">
                      <ParentSalaryComp :value="formData.parentSalary" :validation="validations" :errors="errors" @values="formData.parentSalary = $event" />
                    </validation-provider>
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Tahun</label>
                        <div class="col-sm-4 form-group">
                          <validation-provider #default="{ errors }" name="sequence" rules="required">
                            <b-form-input v-model="formData.sequence" :validation="validations.sequence ? false : null" :errors="errors"></b-form-input>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Nilai Tambah</label>
                        <div class="col-sm-4 form-group">
                          <validation-provider #default="{ errors }" name="addValue" >
                            <b-form-input v-model="formData.addValue" :validation="validations.addValue ? false : null"></b-form-input>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>
                        </div>
                    </div>
                </div>
                <div class="box-footer right">
                    <b-button class="back" @click="toPage('/standart-salary')"><span>Kembali</span></b-button>
                    <b-button variant="primary" @click="Save()">
                      <b-spinner small v-if="isBusy" variant="success"></b-spinner>
                      <span v-if="!isBusy">Simpan</span>
                    </b-button>
                </div>
            </validation-observer>
        </b-card>
    </div>
</template>

<script>
import {
    BFormInput,
    BCard,
    BFormSelect,
    BButton,
    BSpinner
} from "bootstrap-vue";
import GradeComp from '../../components/Grade/GradeComp';
import PositionComp from '../../components/Position/PositionComp';
import ParentSalaryComp from '../../components/Base/ParentSalaryComp';
import { required } from "@validations";

import { ValidationProvider, ValidationObserver } from "vee-validate"
import utility from '../../libs/utility'
export default {
  data() {
    return {
        formData:  {
            grade:    null,
            position: null,
            parentSalary: null,
            sequence:     '',
            addValue:     '',

        },
        isBusy:         false,
        validationForm: null,
        validations:  {}
    }
  },
  components: {
    BFormInput,
    BCard,
    BFormSelect,
    BButton,
    required,
    GradeComp,
    PositionComp,
    ParentSalaryComp,
    ValidationProvider,
    ValidationObserver,
    BSpinner
  },
  methods: {
    toPage(page) {
      this.$router.push(page);
    },
    Save() {
        this.$refs.salaryValidation.validate()
          .then((result) => {
             console.log(result);
             if (result) {
                let req   =   {
                  addValue:            this.formData.addValue,
                  gradeId:             this.formData.grade.value.gradeId,
                  jobTitleId:          this.formData.position.value.jobTitleId,
                };
                if (this.formData.parentSalary !== null) {
                  req['parentSalaryStandar']  =  this.formData.parentSalary.value.salaryStandardId
                }
                console.log(req);
                this.isBusy    =  true;
                this.$http.post('/mastering/salaryStandard',req)
                 .then((result) => {
                   console.log(result);
                   if (utility.ResponseCode(result)) {
                     this.isBusy    =    false;
                     this.$bvToast.toast(result.data.message, {
                       title: result.data.message,
                       autoHideDelay: 5000,
                     });
                     setTimeout(() => {
                       this.$router.push('/standart-salary');
                     },1000)
                   }
                 });
             }
          });
    },
    ReadUpdate() {
        let id      =    this.$route.params.id;
        if (utility.isEmpty(id)) {
          this.$http.get('/mastering/salaryStandard/'+id)
            .then((result) => {
              console.log(result);
              this.formData.grade     =    {
                 text:    result.data.data.grade.gradeName,
                 value:   result.data.data.grade
              };
              this.formData.position  =    {
                text:     result.data.data.jobTitle.positionName,
                value:    result.data.data.position
              };
              this.formData.parentSalary =  {
                text:     result.data.data.parentSalaryStandar.jobTitle.positionName,
                value:    result.data.data.parentSalaryStandar
              };
              this.formData.sequence     =  result.data.data.sequence;
              this.formData.addValue     =  result.data.data.addValue;
            });
        }
        console.log(id);
    }
  },
  mounted() {
    this.ReadUpdate();
  }
};
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/vue-select.scss";
</style>
